import { useParams } from "react-router-dom";

import { getLinkedFirm } from "../../../../../../../../sessionStorage/sessionStorage";
import { useGetContactQuery } from "../../../../../../../../slices/ContactsSlice";
import { ProfileEmailsWidget } from "../../../../../../components/profile";

export const ContactEmailsWidget = () => {
  const { customerId } = useParams<{ customerId: string }>();
  const orgId = getLinkedFirm()?.orgId || "";

  const { data: contact } = useGetContactQuery(
    {
      customerId: customerId || "",
      orgId,
    },
    { skip: !customerId || !orgId },
  );

  const primaryEmail = contact?.emails?.find((email) => email.isPrimaryEmail);
  const contactEmail =
    primaryEmail?.emailAddress || contact?.emails?.[0]?.emailAddress || "";

  return (
    <ProfileEmailsWidget
      contactEmail={contactEmail}
      route={`/contact/${customerId}/emails`}
    />
  );
};
